import React, {useState} from 'react';
import {Grid} from "@mui/material";
import PayoutFilter from "../../components/supplier-ready-for-payout/PayoutFilter";
import {requestReadyForPayoutTransactionsForAccount} from "../requests/account-report";
import {getErrorMessageForNonStandardAndStandardResponse} from "../../util/NetworkErrorUtil";
import PayoutTransactionList from "../../components/supplier-ready-for-payout/PayoutTransactionList";
import {withSnackbar} from "../../components/hocs/withSnackbar";
import PayoutReportDataSummary from "../../components/supplier-ready-for-payout/PayoutReportDataSummary";
import TotalPayout from "../../components/supplier-ready-for-payout/TotalPayout";
import InitiatePayouts from "../../components/supplier-ready-for-payout/InitiatePayouts";
import useAllLocationNames from "../../hooks/components/location/useAllLocationNames";
import {hasAdminAccess} from "../../util/AccountUtils";
import SecurSpaceContainer from '../../components/common/SecurSpaceContainer';
import Pagination from "../../components/deprecatedUikit/Pagination/Pagination";
import InfoCardLoader from "../../components/deprecatedUikit/InfoCard/InfoCardLoader";
import {SecurSpaceReportContainer, SecurSpaceReportTitle} from "../../components/common";


const SupplierReadyForPayout = ({account, snackbarShowMessage}) => {
  const [reportQuery, setReportQuery] = useState({
    sortBy: 'INVOICE_NUMBER',
    sortDir: 'asc',
    locationId: '',
    page: 0,
    size: 50
  });
  const [payoutTransactions, setPayoutTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLocationName, setSelectedLocationName] = useState('');
  const [totalNumberResults, setTotalNumberResults] = useState(0);

  const locations = useAllLocationNames(snackbarShowMessage);

  const getData = (filteredQuery) => {
    if (!account?.id) {
      setLoading(false);
      return;
    }
    setLoading(true);
    requestReadyForPayoutTransactionsForAccount(filteredQuery)
      .then((response) => {
        setReportQuery(filteredQuery);
        const {content, count} = response.body;
        setTotalNumberResults(count);
        setPayoutTransactions(content);
      }).catch((error) => {
        snackbarShowMessage(getErrorMessageForNonStandardAndStandardResponse(error), "error", 15000)
      }).finally(() => {
        setLoading(false);
      });
  };

  const handleFilterChange = (filter) => {
    const queryObject = {
      ...reportQuery,
      sortBy: filter.sortBy,
      sortDir: filter.sortDir,
      locationId: filter.location?.id || '',
      page: 0 // Reset to first page on new query
    };

    getData(queryObject);
    setSelectedLocationName(filter.location?.id && filter.location?.locationName ? filter.location?.locationName : '');
  };

  const updatePaging = (page, size) => {
    if (page !== reportQuery.page || size !== reportQuery.size) {
      getData({
        ...reportQuery,
        page,
        size
      });
    }
  }

  return (
    <SecurSpaceContainer>
      <SecurSpaceReportContainer rowGap={'1rem'}>
        <Grid container item xs={12} justifyContent={'space-between'}>
          <SecurSpaceReportTitle>Ready for Payout</SecurSpaceReportTitle>
          { hasAdminAccess(account) &&
            <InitiatePayouts payoutTransactions={payoutTransactions} accountId={account.id} locations={locations} />
          }
        </Grid>
        <PayoutFilter
          onFilterChange={handleFilterChange}
          locations={locations}
        />
        <PayoutReportDataSummary
          query={reportQuery}
          count={payoutTransactions.length}
          title={'Transactions Ready for Payout'}
        />
        {
          loading ? [...Array(10).keys()].map((_, index) => (
            <InfoCardLoader key={index} />
          )) : <>
            <TotalPayout payoutTransactions={payoutTransactions} title={selectedLocationName} gridItemProps={{ mb: 2 }}/>
            <PayoutTransactionList payoutTransactions={payoutTransactions} loading={loading} />
          </>
        }
        {
          payoutTransactions.length > 0 && <Grid item container justifyContent={'end'} sx={{ mt:4 }}>
            <Pagination
              count={totalNumberResults}
              rowsPerPage={reportQuery.size}
              page={reportQuery.page}
              onPageChange={(_event, page) => updatePaging(page, reportQuery.size)}
              onRowsPerPageChange={(event) => updatePaging(0, event.target.value)}
              variant="tablePagination"
              scrollToBottomOnPageChange={true}
            />
          </Grid>
        }
      </SecurSpaceReportContainer>
    </SecurSpaceContainer>
  );
};

export default withSnackbar(SupplierReadyForPayout);
